import React, { useState } from "react";
import * as Icons from "lucide-react";
import { STATUS } from "@/mock/data";
import { CompactMatterRow } from "@/components/MatterCard";
import { VolverEnCurso } from "@/components/asuntos/CierreAsunto";

const fechaRef = (m) => (m.status === STATUS.DONE ? m.cerrado_en || "" : `${m.due_date || ""}T${m.due_time || "00:00"}`);

const Plegable = ({ id, label, items }) => {
  const [abierto, setAbierto] = useState(false);
  if (!items.length) return null;
  const orden = [...items].sort((a, b) => fechaRef(b).localeCompare(fechaRef(a)));
  return (
    <section data-testid={`historico-${id}`} className="bg-white border border-[#E5DFD5] rounded-2xl overflow-hidden">
      <button data-testid={`historico-${id}-toggle`} onClick={() => setAbierto(!abierto)} aria-expanded={abierto}
        className="w-full min-h-[56px] flex items-center gap-3 px-4 text-left hover:bg-[#FAF8F5]">
        {id === "hechos" ? <Icons.CheckCircle2 size={20} className="text-[#3A6B56]" /> : <Icons.History size={20} className="text-[#6B7280]" />}
        <span className="flex-1 font-heading font-bold text-base text-[#1C2421]">{label} <span className="text-[#6E7A74]">· {items.length}</span></span>
        <Icons.ChevronDown size={20} className={`text-[#6E7A74] transition-transform duration-200 ${abierto ? "rotate-180" : ""}`} />
      </button>
      {abierto && <div className="px-3 pb-3 space-y-2.5" data-testid={`historico-${id}-lista`}>{orden.map((m, i) => (
        <div key={m.id} className="space-y-1.5">
          <CompactMatterRow matter={m} index={i} />
          {m.recordatorio_puntual && m.status === STATUS.DONE && <VolverEnCurso m={m} testid={`historico-volver-${m.id}`} className="w-full" />}
        </div>
      ))}</div>}
    </section>
  );
};

export const esHistorico = (m) => m.status === STATUS.PAST || m.status === STATUS.DONE;

// Asuntos pasados y hechos: fuera de los paneles activos, plegados y del más reciente al más antiguo.
export const HistoricoAsuntos = ({ matters }) => (
  <div className="space-y-3" data-testid="historico-asuntos">
    <Plegable id="pasados" label="Pasados" items={matters.filter((m) => m.status === STATUS.PAST)} />
    <Plegable id="hechos" label="Hechos" items={matters.filter((m) => m.status === STATUS.DONE)} />
  </div>
);
